var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconHome(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.2859 8.15625L14.0625 6.93366V3.9375C14.0625 3.47344 13.6828 3.09375 13.2188 3.09375H12.375C11.9109 3.09375 11.5312 3.47344 11.5312 3.9375V4.40409L9.84375 2.71828C9.61341 2.50059 9.40247 2.25 9 2.25C8.59753 2.25 8.38659 2.50059 8.15625 2.71828L2.71406 8.15625C2.45081 8.43047 2.25 8.63044 2.25 9C2.25 9.47503 2.6145 9.84375 3.09375 9.84375H3.9375V14.9062C3.9375 15.3703 4.31719 15.75 4.78125 15.75H6.46875C6.93474 15.75 7.3125 15.3722 7.3125 14.9062V11.5312C7.3125 11.0672 7.69219 10.6875 8.15625 10.6875H9.84375C10.3078 10.6875 10.6875 11.0672 10.6875 11.5312V14.9062C10.6875 15.3722 10.6434 15.75 11.1094 15.75H13.2188C13.6828 15.75 14.0625 15.3703 14.0625 14.9062V9.84375H14.9062C15.3855 9.84375 15.75 9.47503 15.75 9C15.75 8.63044 15.5492 8.43047 15.2859 8.15625Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconHome);
export default __webpack_public_path__ + "static/media/IconHome.805b6b382e76e63c4f586035a9b27e1b.svg";
export { ForwardRef as ReactComponent };